import React from "react";
import { Offcanvas } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  selectEventHandlers,
  selectWorkflows,
} from "../../../store/slices/projectSlice";

function InheritedContactSets() {
  const params = useParams();
  const navigate = useNavigate();
  const workflows = useSelector(selectWorkflows);
  const eventHandlers = useSelector(selectEventHandlers);

  const inheritedFromPorts = [];

  workflows.forEach((workflow) => {
    workflow.EventListeners?.forEach((el) =>
      eventHandlers
        .find((eh) => eh.UUID === el.EventHandlerUUID)
        ?.Rules.forEach((rule) =>
          rule.Actions?.forEach((action) => {
            if (
              action.TypeUUID === params.workflowUUID &&
              action.InheritContactSet
            ) {
              inheritedFromPorts.push({
                title: workflow.Label,
                workflowUUID: workflow.UUID,
                event: el.EventType,
                listenerUUID: el.UUID,
                actionUUID: action.UUID,
              });
            }
          })
        )
    );
  });

  return inheritedFromPorts?.length > 0 ? (
    <Offcanvas
      show
      placement="end"
      onHide={() => navigate(`/library/logic/builder/${params.projectID}`)}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>Inherits dynamic group from</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <ul className="list-group">
          {inheritedFromPorts.map((port) => (
            <li className="list-group-item" key={port.workflowUUID}>
              <Link
                to={`/library/logic/builder/${params.projectID}/workflow/${port.workflowUUID}/event/${port.event}/listener/${port.listenerUUID}/action/${port.actionUUID}`}
                state={{ nextPage: -1 }}
              >
                {port.title}
              </Link>
            </li>
          ))}
        </ul>
      </Offcanvas.Body>
    </Offcanvas>
  ) : (
    ""
  );
}

export default InheritedContactSets;
